<template>
    <ui-modal :title="'Invite new User to '+organization.name" v-if="organization"
              :close="() => { close(); afterClose?afterClose():null; }">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg class="h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="#4487f6"
                     viewBox="0 0 1920 1920"
                     stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                          d="M1707 1760c0 29.44-23.893 53.333-53.333 53.333h-320c-29.44 0-53.334-23.893-53.334-53.333v-266.667H1707V1760ZM213.667 1484.053V1337.6c0-86.613 56.426-162.133 140.48-187.947 182.826-56 373.12-82.24 562.346-82.986 146.88.746 292.8 19.413 436.267 54.4-44.053 39.04-72.427 95.466-72.427 158.933v106.667h-106.666v288.32c-87.467 20.266-176.96 31.68-266.667 31.68-144.427 0-423.467-29.334-693.333-222.614ZM1387 1280c0-58.773 47.893-106.667 106.667-106.667 58.773 0 106.666 47.894 106.666 106.667v106.667H1387V1280ZM899.533 106.667h14.934c174.08 0 322.346 122.56 357.653 290.24-30.187 17.493-61.44 29.76-115.52 29.76-69.547 0-101.12-19.947-141.227-45.227-45.653-28.8-97.28-61.44-196.906-61.44-100.374 0-152.32 32.747-198.187 61.653-26.773 16.96-49.813 31.467-82.987 39.147 25.28-177.28 178.134-314.133 362.24-314.133Zm807.467 1280V1280c0-61.653-26.667-116.8-68.587-155.733l.107-.107c-37.867-43.733-123.093-69.76-146.88-76.267-100.373-30.826-202.88-53.013-306.453-67.626C1306.893 894.72 1387 753.813 1387 594.133h-106.667c0 201.707-164.16 365.867-365.866 365.867h-14.934c-201.706 0-365.866-164.16-365.866-365.867v-64.32c66.24-9.173 106.88-34.773 143.573-57.92 40.107-25.28 71.787-45.226 141.227-45.226 68.693 0 100.16 19.84 139.946 45.013 45.867 28.907 97.814 61.653 198.187 61.653 100.373 0 152.533-33.066 202.453-64.746l28.267-18.027-3.84-33.28C1355.427 179.413 1153.72 0 914.467 0h-14.934C638.947 0 427 211.947 427 480v114.133c0 159.787 80.107 300.694 201.92 386.24-103.36 14.507-205.653 36.587-306.133 67.307C193.72 1087.36 107 1203.84 107 1337.6v200.213l21.333 15.894C429.453 1779.627 745.4 1813.333 907 1813.333c90.453 0 180.48-11.52 268.907-30.506 11.306 77.333 77.333 137.173 157.76 137.173h320c88.213 0 160-71.787 160-160v-373.333H1707Z"/>
                </svg>
            </div>
        </template>
        <div class="w-full text-sm - text-gray-500 mb-3">Please give the Users name and an Email Address/Phone number:
        </div>
        <div class="flex mt-2 grid">
            <ui-input name="name"
                      label="Name:"
                      placeholder="Users name" type="text"
                      v-model="name"
                      :disabled="busy"
                      field="w-full"
            ></ui-input>
        </div>
        <div class="flex mt-1 grid">
            <ui-input name="contact"
                      label="Email Address or Phone Number:"
                      placeholder="Phone number or Email Address..." type="text"
                      v-model="emailAddressOrPhoneNumber"
                      @input="emailError = ''"
                      :disabled="busy"
                      :error="emailError"
                      field="w-full"
            ></ui-input>
        </div>
        <div class="flex mt-1 grid">
            <label class="block text-sm font-medium text-gray-700 mb-1" v-text="'Permissions'"></label>
            <organization-permission-selector :available-permissions="organization.availablePermissions"
                                              :packages="packages"
                                              v-for="(permission,index) in permissions"
                                              :key="index"
                                              @update="(e) => Object.assign(permission,e)"
                                              :removable="true"
                                              @remove="permissions.splice(index,1)"
                                              :option="permission"></organization-permission-selector>
            <div class="mt-1">
                <ui-button-new small @click="addPermission" :disabled="busy">Add Permission
                </ui-button-new>
            </div>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap" @click="sendInvite" :disabled="busy"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import UiInput from "../ui/UiInput.vue";
import PackageContactSearch from "../contacts/PackageContactSearch.vue";
import UiDataGridItem from "../ui/UiDataGridItem.vue";
import UiDataGrid from "../ui/UiDataGrid.vue";
import UiSelect from "../ui/UiSelect.vue";
import UiSelectSearchable from "../ui/UiSelectSearchable.vue";
import PageCell from "../ui/PageCell.vue";
import MessageWidgetChannelAvatars from "../widgets/MessageWidget/MessageWidgetChannelAvatars.vue";
import UiDropdown from "../ui/UiDropdown.vue";
import {uuid} from "../../utils";
import OrganizationPermissionSelector from "./OrganizationPermissionSelector.vue";

export default {
    components: {
        OrganizationPermissionSelector,
        UiDropdown,
        MessageWidgetChannelAvatars,
        PageCell,
        UiSelectSearchable, UiSelect, UiDataGrid, UiDataGridItem, PackageContactSearch, UiInput
    },
    props: {
        handle: Function,
        close: Function,
        afterClose: Function,
        button: {
            type: String,
            default: 'Send Invitation'
        },
        organization: Object,
        packages: Array,
        attendees: [],
        contacts: {}
    },
    data() {
        return {
            permissions: [],
            search: '',
            name: '',
            emailAddressOrPhoneNumber: '',
            busy: false,
            emailError: ''
        }
    },
    methods: {
        async sendInvite() {
            this.busy = true;
            // apply global actions to all scopes....
            this.permissions.forEach((permission) => {
                if (permission.scopes && permission.scopes.packageReference) { // PackageReference scope
                    permission.scopes.packageReference.forEach((i) => {
                        i.actions = permission.actions
                    })
                }
            })
            this.emailError = '';
            await this.organization.invite(uuid(), this.name, this.emailAddressOrPhoneNumber, this.permissions)
                .catch((error) => {
                    this.emailError = error.response.data.message;
                    this.busy = false;
                }).then(() => {
                    if (this.emailError === '') {
                        this.handle(this)
                    }
                })
        },
        addPermission() {
            let first = this.organization.availablePermissions[0];
            let scopes = first.scopes.includes('packageReference') ? {packageReference: []} : {}
            let ob = {
                id: uuid(),
                context: first.context,
                name: first.name,
                type: first.type,
                scopes: scopes,
                actions: [],
            }
            this.permissions.push(ob)
        }
    },
    async mounted() {
    }
}
</script>
